import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-159" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-160" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-161" data-mp="32p5qer82vgu2">
          🧴 Facial PRO 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-162" data-mp="36nd5lhmw8a35">
          El sistema para profesionales de estética facial en Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-163" data-mp="39922nzchmct">
          Porque una limpieza facial no debería ser un juego de azar.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-164" data-mp="3le2icog05x94">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-165" data-mp="29zgl41oc4umn">
            <MailIcon className="h-4 w-4" data-id="element-166" data-mp="3l9k7pidf7xfx" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-167" data-mp="3lbdecxo1ahnx">
            <GlobeIcon className="h-4 w-4" data-id="element-168" data-mp="3q7u0xnfl4nyw" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-169" data-mp="828lk264fx7k">
            <InstagramIcon className="h-4 w-4" data-id="element-170" data-mp="ctqogvrpg7v6" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-171" data-mp="cw34329zq652">
          <p className="text-base font-black text-ink" data-id="element-172" data-mp="qub79rxme3oo">
            🧴 “El próximo protocolo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-173" data-mp="mptptzeqg2h2">
            “Finalmente sesiones con confianza profesional.”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-174" data-mp="ytei8br202q3">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-175" data-mp="13rzj8de4qqfl" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}